module.exports = __webpack_public_path__ + "static/media/carpediemHorizontalLogo.93237b3d.svg";